import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 72px;
  font-family: Spoqa Han Sans Neo;
`;

const SelectedPatternBox = styled.div`
  width: 100%;
  position: relative;
`;
const PatternCategory = styled.div`
  display: flex;
  flex-direction: row;
`;
const PatternCategoryTitle = styled.div`
  width: 274px;
  height: 66px;
  padding: 20px 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px 12px 0px 0px;
  border: 1px solid #e5e8ea;
  border-bottom: none;
  font-size: 18px;
  font-weight: 500;
  color: #222;
`;
const PatternContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border: 1px solid #e5e8ea;
`;

const PatternBox = styled.div`
  width: 274px;
  height: 220px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 11px;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow-y: auto;
  border-right: 1px solid #e5e8ea;
  font-size: 12px;
  font-weight: 500;
  color: #616161;
  white-space: nowrap;
`;

const BottomButtonBox = styled.div`
  width: 100%;
  height: 99px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  border: 1px solid #e5e8ea;
  border-top: none;
  padding: 0 24px;
`;
const SaveButton = styled.button`
  width: 132px;
  height: 51px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #008aff;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: #008aff;
  cursor: pointer;
`;
const NextButton = styled.button`
  width: 132px;
  height: 51px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: #008aff;
  background-color: #eaf2fe;
  cursor: pointer;
`;
const SaveDoneButton = styled.button`
  width: 132px;
  height: 51px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: rgba(55, 56, 60, 0.28);
  background-color: rgba(55, 56, 60, 0.16);
  cursor: pointer;
`;

const AnalyzeButton = styled.button`
  width: 132px;
  height: 51px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: #fff;
  background-color: #008aff;
  cursor: pointer;
`;

const ShowMoreButton = styled.div`
  width: 100%;
  // height: 59px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background-color: rgba(112, 115, 124, 0.05);
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 400;
  color: #000;
  border: 1px solid #e5e8ea;
  border-top: none;
  cursor: pointer;
  padding: 11px 16px;
  border-radius: 0px 0px 12px 12px;
`;

const SaveModal = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.52);
`;

const SaveModalInner = styled.div`
  width: 420px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: #fff;
  border-radius: 20px;
  border: 1px solid #e1e2e4;
  box-shadow: 0px 4px 15px 0px rgba(141, 149, 163, 0.25);

  img {
    cursor: pointer;
  }
`;
const ModalTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;
const InputBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #616161;
`;
const PatternInput = styled.input`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background: #f5f7fa;
  padding: 0 16px;
  margin-top: 4px;
  border: none;

  &:placeholder {
    color: rgba(158, 165, 181, 0.6);
  }
`;
const GuideText = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;

const ModalButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
const CancelButton = styled.button`
  width: 86px;
  height: 47px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: rgba(112, 115, 124, 0.08);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
`;

export const s = {
  Container,
  SelectedPatternBox,
  PatternCategory,
  PatternCategoryTitle,
  PatternContent,
  PatternBox,
  BottomButtonBox,
  NextButton,
  AnalyzeButton,
  ShowMoreButton,
  SaveButton,
  SaveModal,
  SaveModalInner,
  ModalTitle,
  InputBox,
  PatternInput,
  GuideText,
  ModalButtonBox,
  CancelButton,
  SaveDoneButton,
};
